import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <div className="footer">
      <p>&copy; 2020 by Samuel </p>
      <p><a className="footer-links" href="https://github.com/samueltrahan/react.lion">Theme</a> by <a className="footer-links" href="https://www.cinquewd.com">Cinque Web Development</a></p>
    </div>
  )
}
